import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DashboardIndicadoresGerais, IndicadorInfo } from '../../dashboard.model';

@Injectable({ providedIn: 'root' })
export class DashboardGeralService {
    private url = `${environment.managerURL}/dashboard`;

    constructor(private http: HttpClient) {}

    getIndicadoresGerais(): Observable<DashboardIndicadoresGerais> {
        return this.http.get<DashboardIndicadoresGerais>(`${this.url}/indicadores-gerais`);
    }

    buildIndicadoresGerais(data: DashboardIndicadoresGerais | null): IndicadorInfo[] {
        if (!data) return [];

        return [
            {
                titulo: 'Equipamentos',
                valor: data.equipamentos,
                icone: 'precision_manufacturing',
                cor: 'success',
                descricao: 'Quantidade total de equipamentos cadastrados no sistema',
                periodicidade: 'Geral'
            },
            {
                titulo: 'Contratos',
                valor: data.contratos,
                icone: 'assignment',
                cor: 'primary',
                descricao: 'Quantidade total de contratos ativos e cadastrados',
                periodicidade: 'Geral'
            },
            {
                titulo: 'Beneficiárias',
                valor: data.beneficiarias,
                icone: 'business',
                cor: 'accent',
                descricao: 'Quantidade total de beneficiárias cadastradas',
                periodicidade: 'Geral'
            },
            {
                titulo: 'Condutores',
                valor: data.condutores,
                icone: 'person',
                cor: 'success',
                descricao: 'Quantidade total de condutores cadastrados',
                periodicidade: 'Geral'
            },
            {
                titulo: 'Aferidores Ativos',
                valor: data.aferidores,
                icone: 'verified_user',
                cor: 'primary',
                descricao: 'Quantidade total de aferidores ativos no sistema',
                periodicidade: 'Geral'
            },
            {
                titulo: 'DIOs Criados',
                valor: data.totalDiosCriados,
                icone: 'add_circle',
                cor: 'primary',
                descricao: 'Total de DIOs criados no sistema',
                periodicidade: 'Geral'
            },
            {
                titulo: 'DIOs Executados',
                valor: data.totalDiosExecutados,
                icone: 'check_circle',
                cor: 'success',
                descricao: 'Total de DIOs que tiveram sua execução iniciada pelos condutores',
                periodicidade: 'Geral'
            },
            {
                titulo: 'DIOs Cancelados',
                valor: data.totalDiosCancelados,
                icone: 'cancel',
                cor: 'warn',
                descricao: 'Total de DIOs cancelados',
                periodicidade: 'Geral'
            }
        ];
    }
}
